import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import SAVE_ICON from "../../../assets/check-mark.png";
import CLOSE_ICON from "../../../../assets/closeModel.png";
import RESET_ICON from "../../../assets/trash.png";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";
import Notification from "../../../../components/common/notification/Notification";
import { useSelector } from "react-redux";
import {
  deleteSmsTemplateAction,
  setDeleteSmsTemplateSuccessAction,
} from "../../../../store/reducers/smsTemplateSlice";

interface DeletePopupProps {
  deleteRec?: any;
  onHide?: () => void;
  deleteModalShow: boolean;
  setDeleteModalShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  clientDetails?: any;
  setIsUpdated?: any;
}

const DeletePopup: React.FC<DeletePopupProps> = ({
  deleteRec,
  onHide,
  deleteModalShow,
  setDeleteModalShow,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { isDeleteSmsTemplateSuccess } = useSelector(
    (state: any) => state?.smsTemplate
  );

  console.log("deleteRec", deleteRec);
  const submitHandler = () => {
    const payload = { deleteRec };
    dispatch(deleteSmsTemplateAction(deleteRec));
  };

  useEffect(() => {
    if (isDeleteSmsTemplateSuccess) {
      dispatch(setDeleteSmsTemplateSuccessAction(false));
      setDeleteModalShow(false);
    }
  }, [isDeleteSmsTemplateSuccess]);

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition
  return (
    <Popup
      open={deleteModalShow}
      title={"Confirm Deletion"}
      onHide={() => setDeleteModalShow(false)}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={onHide}
            src={CLOSE_ICON}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          {isDeleteSmsTemplateSuccess ? (
            <CustomButton variant="outlined" title="Close" onClick={onHide} />
          ) : (
            <>
              <CustomButton variant="outlined" title="No" onClick={onHide} />
              <CustomButton title="Yes" onClick={submitHandler} />
            </>
          )}
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <>
            <Notification />
            <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              Are you sure you want to delete this template?
            </Alert>
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default DeletePopup;
